import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const conversations = (rawClient) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/conversations'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/conversations/:id'),
    search: allpeepNoPayloadEndpoint(rawClient, '/conversations/search'),
    newPost: allpeepPayloadEndpoint(rawClient, '/conversations/:id/posts'),
    leave: allpeepNoPayloadEndpoint(rawClient, '/conversations/:id/leave', 'delete'),
    archived: allpeepNoPayloadEndpoint(rawClient, '/conversations/archived'),
});
